export const isTranslationDisabled = (isDefaultOffice, serverTime) => {
  const now = new Date(serverTime * 1000);
  const nowWithoutTimezone =
    now.valueOf() + now.getTimezoneOffset() * 60 * 1000;
  const nowInMoscow = new Date(nowWithoutTimezone + 3 * 60 * 60 * 1000);
  const hoursInMoscow = nowInMoscow.getHours();

  return isDefaultOffice
    ? hoursInMoscow < 8 || hoursInMoscow >= 20
    : hoursInMoscow < 10 || hoursInMoscow >= 22;
};

export default isTranslationDisabled;
